import type { DOMNode } from 'html-react-parser';
import { Accordion } from './Accordion';
import type { EnhancedDOMNode } from './Include';

type Props = {
  elementsToRender?: DOMNode[];
};

export const CollapseContainer = (props: Props) => {
  let panel: EnhancedDOMNode[] | undefined;
  let header: EnhancedDOMNode[] | undefined;

  function removeDisplayNone(nodes: EnhancedDOMNode[]) {
    return nodes.map((node) => {
      if (node?.attribs?.['class']?.includes('collapse_component_container')) {
        node.attribs['style'] = node?.attribs['style']?.replace(
          'display:none;',
          'display:block;'
        );
      }

      if (node?.children) {
        removeDisplayNone(node.children);
      }

      return node;
    });
  }

  if (props.elementsToRender) {
    (props.elementsToRender as EnhancedDOMNode[]).forEach((el) => {
      if (el.attribs?.['class'] === 'collapse_component_title_wrap') {
        header = el.children;
      }

      if (el.tagName === 'collapsecontainer') {
        panel = removeDisplayNone(el.children);
      }
    });
  }

  return <Accordion header={header} panel={panel} />;
};

export default CollapseContainer;
